export const addOpacityToColor = (hexColor) => `${hexColor}20`;
